/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIGuestUserRequest } from './APIGuestUserRequest';
import {
    APIGuestUserRequestFromJSON,
    APIGuestUserRequestFromJSONTyped,
    APIGuestUserRequestToJSON,
} from './APIGuestUserRequest';

/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIPatchedFeedbackSubmissionRequest
 */
export interface APIPatchedFeedbackSubmissionRequest {
    /**
     * The submission for feedback_form decoded as s JSON string.
     * @type {{ [key: string]: any; }}
     * @memberof APIPatchedFeedbackSubmissionRequest
     */
    submission?: { [key: string]: any; };
    /**
     * 
     * @type {Date}
     * @memberof APIPatchedFeedbackSubmissionRequest
     */
    readAt?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof APIPatchedFeedbackSubmissionRequest
     */
    article?: string;
    /**
     * 
     * @type {string}
     * @memberof APIPatchedFeedbackSubmissionRequest
     */
    feedbackForm?: string;
    /**
     * 
     * @type {APIGuestUserRequest}
     * @memberof APIPatchedFeedbackSubmissionRequest
     */
    submittedBy?: APIGuestUserRequest;
}

/**
 * Check if a given object implements the APIPatchedFeedbackSubmissionRequest interface.
 */
export function instanceOfAPIPatchedFeedbackSubmissionRequest(value: object): value is APIPatchedFeedbackSubmissionRequest {
    return true;
}

export function APIPatchedFeedbackSubmissionRequestFromJSON(json: any): APIPatchedFeedbackSubmissionRequest {
    return APIPatchedFeedbackSubmissionRequestFromJSONTyped(json, false);
}

export function APIPatchedFeedbackSubmissionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPatchedFeedbackSubmissionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'submission': json['submission'] == null ? undefined : json['submission'],
        'readAt': json['read_at'] == null ? undefined : (new Date(json['read_at'])),
        'article': json['article'] == null ? undefined : json['article'],
        'feedbackForm': json['feedback_form'] == null ? undefined : json['feedback_form'],
        'submittedBy': json['submitted_by'] == null ? undefined : APIGuestUserRequestFromJSON(json['submitted_by']),
    };
}

export function APIPatchedFeedbackSubmissionRequestToJSON(value?: APIPatchedFeedbackSubmissionRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'submission': value['submission'],
        'read_at': value['readAt'] == null ? undefined : ((value['readAt'] as any).toISOString()),
        'article': value['article'],
        'feedback_form': value['feedbackForm'],
        'submitted_by': APIGuestUserRequestToJSON(value['submittedBy']),
    };
}

